import { Tooltip } from 'react-tooltip'
import { useIntl } from 'react-intl'
import { PhoneProviderActions } from '../../components/telephony/PhoneProviderActions'
import { AGENT_TOOLTIP_MESSAGES as M } from './sharedMessages'

interface AgentInfoTooltipProps {
  id: string
  /** Si no se pasa, se usa el título por defecto traducido. */
  title?: string
  user: {
    firstName: string
    lastName: string
    email: string
    cellphone?: string | null
  } | null
}

export const AgentInfoTooltip: React.FC<AgentInfoTooltipProps> = ({ id, title, user }) => {
  const intl = useIntl()
  // El título por defecto no puede vivir en la firma: necesita `intl`.
  const heading = title ?? intl.formatMessage(M.title)

  // Si no hay usuario, no mostrar tooltip
  if (!user) {
    return (
      <Tooltip
        delayHide={500}
        clickable={true}
        id={id}
        place='bottom'
        className='tooltip-tfi tooltip-clean'
      >
        <div className='tooltip-tfi' style={{ color: '#222' }}>
          <p>{intl.formatMessage(M.noAgent)}</p>
        </div>
      </Tooltip>
    )
  }

  return (
    <Tooltip
      delayHide={500}
      clickable={true}
      id={id}
      place='bottom'
      className='tooltip-tfi tooltip-clean'
    >
      <div className='tooltip-tfi' style={{ color: '#222' }}>
        <h6 className='text-center'>{heading}</h6>

        <div className='element'>
          <p className='fw-bold'>{intl.formatMessage(M.name)}</p>
          <p>{user.firstName} {user.lastName}</p>
        </div>

        <div className='element'>
          <p className='fw-bold'>{intl.formatMessage(M.email)}</p>
          <p style={{ maxWidth: '140px', wordBreak: 'break-all' }}>{user.email}</p>
        </div>

        <div className='element'>
          <p className='fw-bold'>{intl.formatMessage(M.phone)}</p>
          <PhoneProviderActions phone={user.cellphone} />
        </div>
      </div>
    </Tooltip>
  )
}
